/*
 * @Author: Teemo Ding
 * @Date: 2022-04-17 10:44:50
 * @LastEditTime: 2022-08-24 16:26:49
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Analytics/Reports/ReportsDetail/config.tsx
 */
import { get } from 'lodash';
import React from 'react';
import { ICategory } from 'src/types/common/report';
import css from './css.module.less';

export const breadcrumbData = (name, { getI18n }) => [
  {
    url: '',
    name: getI18n('general.sider.home'),
  },
  {
    url: '',
    name: getI18n('reports.reportdetailcommon.reports'),
  },
  {
    url: '',
    name,
  },
];

export const columns = (dimensions, metrics, type, { getI18n }) => {
  const dimensionsFilter = (dimensions || []).filter((o, index) => index !== 0);
  return (dimensions || []).length
    ? [
        {
          title: get(dimensions, ['0', 'header']),
          default: true,
          optional: false,
          dataIndex: get(dimensions, ['0', 'type']),
          className: css.columnClass,
          onCell: (_, index) => ({
            rowSpan: 2,
          }),
          minWidth: 180,
          fixed: 'left',
          render: (text, _, index) => {
            return index > 0 ? (
              <div className={css.orderID}>
                {type !== ICategory.Parcel ? '#' : ''} {text}
              </div>
            ) : (
              getI18n('general.summary')
            );
          },
        },
        ...(dimensionsFilter.length
          ? [
              {
                title: getI18n('reports.reportpagecommon.dimensions'),
                default: true,
                optional: false,
                className: css.columnClass,
                minWidth: 668,
                children: dimensionsFilter.map((item, index) => ({
                  title: item.header,
                  key: item.type,
                  default: true,
                  dataIndex:
                    item.type === 'dynamic'
                      ? ['dynamic', item.header]
                      : item.type,
                  className: css.columnClass,
                  with: 140,
                  onCell: (_, index) => ({
                    rowSpan: 0,
                  }),
                })),
              },
            ]
          : []),
        ...((metrics || []).length
          ? [
              {
                title: getI18n('reports.reportpagecommon.metrics'),
                default: true,
                optional: false,
                className: css.columnClass,
                minWidth: 420,
                children: (metrics || []).map((item, index) => ({
                  title: item.header,
                  key: item.type,
                  default: true,
                  dataIndex: item.type,
                  className: css.columnClass,
                  width: 90,
                })),
              },
            ]
          : []),
      ]
    : [];
};
